<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" ref="field"
             :label="label">
        <q-input-frame :error="hasError"
                       :disable="disable"
                       :hide-underline="hideUnderline"
                       :before="before"
                       :after="after"
                       :color="color"
                       class="q-input"
                       :class="{original: original}">
<!--            <slot><span v-html="displayValue" :class="{ ellipsis: type != 'textarea' }"></span></slot>-->
            <slot><span v-html="displayValue"></span></slot>
        </q-input-frame>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import moment from 'moment'
    import {
        date,
        QInputFrame
    } from 'quasar-framework'

    export default {
        name: 'VDisplay',
        components: {QInputFrame},
        mixins,

        props: {
            innerLabel: String,
            negativeLabel: String,
            options: {
                type: Array,
                default() {
                    return []
                }
            },
            type: String,
            format: {
                type: String
            },
            hideUnderline: Boolean,
            original: Boolean,
            emptyMessage: {
                type: String,
                default() {
                    return ''
                }
            }
        },

        computed: {
            displayValue() {
                if (this.options.length > 0) {
                    var result = this.options.filter(option => option.value == this.value)
                    if (result.length === 0) return
                    return result[0].label
                }
                if (this.value === null || typeof(this.value) === "undefined")
                    return this.emptyMessage ? this.emptyMessage : this.$t('not_available')
                if (this.format || moment(this.value, 'DD/MM/YYYY HH:mm', true).isValid())
                    return moment(this.value, 'DD/MM/YYYY HH:mm').format(this.format || this.defaultDateTimeFormat)
                if (this.format || moment(this.value, 'DD/MM/YYYY', true).isValid())
                    return moment(this.value, 'DD/MM/YYYY').format(this.format || this.defaultDateFormat)
                if (this.format || moment(this.value, 'YYYY-MM-DD', true).isValid())
                    return moment(this.value, 'YYYY-MM-DD').format('DD-MM-YYYY')
                if ((this.value === true || this.value === false) || this.negativeLabel)
                    return this.value ? this.innerLabel : this.negativeLabel
                if (typeof this.value === 'string')
                    return this.value.replace(/(?:\r\n|\r|\n)/g, '<br />')
                return this.value
            },

            defaultDateFormat() {
                return this.$t('date_format')
            },

            defaultDateTimeFormat() {
                return this.$t('datetime_format')
            }
        },

        mounted() {
            this.$refs.field.$refs.QField.__registerInput({$options: {}})
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VDisplay.vue